import Hero from './Hero'

export default Hero





// WEBPACK FOOTER //
// ./src/components/shared/elements/Hero/index.js